import { FC } from 'react'
import styles from './tabsSection.module.scss'

interface TabsSectionProps {
  activeTab: 'saved' | 'archived' | 'completed' | 'all'
  allCount: number
  archivedCount: number
  completedCount: number
  onSearchChange?: (value: string) => void
  onTabChange: (tab: 'saved' | 'archived' | 'completed' | 'all') => void
  savedCount: number
  searchValue?: string
}

export const TabsSection: FC<TabsSectionProps> = ({
  activeTab,
  allCount,
  archivedCount,
  completedCount,
  onSearchChange,
  onTabChange,
  savedCount,
  searchValue,
}) => {
  return (
    <div className={styles.tabsSection}>
      <div className={styles.tabsContainer}>
        <button
          className={`${styles.tab} ${activeTab === 'saved' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('saved')}
          type="button"
        >
          Active <span className={styles.tabCount}>{savedCount}</span>
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'archived' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('archived')}
          type="button"
        >
          Draft <span className={styles.tabCount}>{archivedCount}</span>
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'completed' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('completed')}
          type="button"
        >
          Completed <span className={styles.tabCount}>{completedCount}</span>
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'all' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('all')}
          type="button"
        >
          All <span className={styles.tabCount}>{allCount}</span>
        </button>
      </div>
      <div className={styles.tabsRight}>
        <div className={styles.searchBox}>
          <svg
            className={styles.searchIcon}
            fill="none"
            height="20"
            viewBox="0 0 24 24"
            width="20"
          >
            <path
              d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
          <input
            className={styles.searchInput}
            onChange={(e) => onSearchChange?.(e.target.value)}
            placeholder="Search"
            type="text"
            value={searchValue}
          />
        </div>
      </div>
    </div>
  )
}
